import React from "react";
import {browserHistory} from 'react-router';
import { PhotoSwipe } from "react-photoswipe";
import I18n from 'lib/i18n/i18n';
import {
    dataAutomationAttr,
    isMobile,
    LS,
    CLICKED_EDIT_PHOTOS,
    imageUrl,
} from "../../helpers/ApplicationHelper";
import {photosInSameLine} from 'helpers/itemHelper';
import {bindActionCreators} from "redux";
import {clearItemAndCache, clearItem} from "../../actions/item";
import {connect} from "react-redux";
import UserActions from "../../lib/userActions";
import WorthyApi from '../../lib/api/worthyApi';
import UploadImageComponent from './UploadImageComponent';

const HIDDEN_CLASS = 'hidden';

class AdditionalItemDetails extends React.Component {
    constructor(props) {
        super(props);
        this.isMobile = isMobile();
        this.state = {
            clickedGalleryImage: 0,
            isGalleryOpen: false,
            imagesPreloaded: false,
            gallery: [],
            hidePhotos: true,
            loading: false,
            hasPhoto: null,
        }
    }

    toggleHeader = (toShow = false) => {
        if (!this.pageHeader) {
            this.pageHeader = document.querySelector('header');
        }

        if (toShow) {
            this.pageHeader.classList.add(HIDDEN_CLASS);
        } else {
            this.pageHeader.classList.remove(HIDDEN_CLASS);
        }
    }

    handleClose = () => {
        this.toggleHeader();
        this.setState({ isGalleryOpen: false })
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.item.photos) !==  JSON.stringify(this.props.item.photos)) {
            // Who dared to resubmit or change item's submitted photos?
            this.setState({ imagesPreloaded: false });
            this.preloadImages(this.props.item.photos);
        }
    }

    componentDidMount() {
        if (this.props.item && this.props.item.photos && this.props.item.photos.length) {
            this.preloadImages();
        }
    }

    preloadImages = (photos) => {
        const imagesToBeDownload = photos || this.props.item.photos;

        this.gallery = imagesToBeDownload ? imagesToBeDownload.map((src, idx) => {
            const j = document.createElement('img');
            const requestedSrc = src.replace('/upload', '/upload/w_' + (window.innerWidth > 1000 ? 500 : window.innerWidth));
            j.src = requestedSrc;
            // Reducing loading time from Cloudinary transformations.

            j.onload = (data) => {
                if (this.gallery[idx]) {
                    this.gallery[idx]['h'] = data.path ? data.path[0].height : data.target.height;
                    this.gallery[idx]['w'] = data.path ? data.path[0].width : data.target.width;
                }

                if (this.gallery.every(img => img.h && img.w)) {
                    this.setState({
                        imagesPreloaded: true,
                        gallery: this.gallery
                    })
                }
            };
            return { src: requestedSrc }
        }) : [];
    };

    openSwiper = (idx) => {
        const { gallery, imagesPreloaded } = this.state;
        if (gallery && imagesPreloaded) {
            this.toggleHeader(true);
            this.setState({
                clickedGalleryImage: idx,
                isGalleryOpen: true
            })
        }
    }

    logAction = (message) => {
        if (this.props.logger) {
            this.props.logger(message, {});
        }
    };

    toUploadPhotos = (itemId, action) => {
        LS.set(`${CLICKED_EDIT_PHOTOS}_${itemId}`, true)
        this.logAction(`${action} photos clicked`);
        this.props.parentItemId ? this.props.clearItemAndCache(this.props.parentItemId) : this.props.clearItem();
        UserActions.lightListingPage(`${this.props.item.desc} add photo clicked`, itemId, this.props.version)
        browserHistory.push("/item/" + itemId)
    }

    removeImage = (image) => {
        const { item } = this.props;

        WorthyApi.removeImage(item.id, image).then(() => {
            this.props.onDataChange();
        })
    };

    uploadStart = () => {
        this.setState({ loading: true });
    };

    onUploadSuccess = () => {
        this.logAction('add photos clicked');
        this.props.onDataChange();
    };

    render() {
        const { item, clickOnBox, version } = this.props;
        const {
            isGalleryOpen,
            clickedGalleryImage,
            gallery,
            hidePhotos
        } = this.state;

        if (item.photos && item.photos.length){this.logAction('add photo box presented')}

        return <section className={'pane-listing item-details-light-listing'}>
            <span className='item-upper-caption'>#{ item.id }</span>
            <img className={`back-arrow-blue ${hidePhotos && 'open'}`} src={ imageUrl('common/back_arrow_blue.svg')} onClick={() => this.setState({hidePhotos: !hidePhotos})}/>
            <h1 className={`item-name bolder text-capitalize ${hidePhotos && this.isMobile && 'no-space'}`}>{ item.desc }</h1>
            <ul className={`item-details-list ${hidePhotos && this.isMobile && 'hide'} item-details-list ${ photosInSameLine(item) ? 'same-line' : 'different-line' }`}>
                <li className="item-details-list-item">
                    <span className="item-fact-title">{I18n.getString('listingPageLight::itemDetails::photos')}</span>
                    {
                        item.photos && item.photos.length ?
                            <>
                                <PhotoSwipe
                                    key="photoswipe"
                                    options={{ index: clickedGalleryImage }}
                                    isOpen={ isGalleryOpen }
                                    items={ gallery }
                                    onClose={ this.handleClose }/>
                                <ul className={
                                    `
                                    photo-box-list 
                                    ${ photosInSameLine(item) ? ' photo-box-list_flex-start photo-box-list_not-empty ' : '' }
                                    `
                                }> {
                                    item.photos.map((image, idx) => {
                                        return <li
                                            data-automation={ dataAutomationAttr('item-photo-' + idx) }
                                            key={ 'photo-box' + idx }
                                            className="photo-box"
                                            style={ { backgroundImage: `url(${ image })` } }
                                            onClick={ () => {
                                                this.openSwiper(idx);
                                            } }
                                        >
                                            <span className="remove-icon"
                                                  onClick={ (event) => {
                                                      event.stopPropagation();
                                                      this.removeImage(image);
                                                  }
                                                  }/>
                                        </li>;
                                    }) }
                                    <li data-automation={dataAutomationAttr('studio-photos-black-box')}
                                        key={'photo-box-black-box'} className="additional-photo">
                                        <UploadImageComponent
                                            item={ item }
                                            clickOnBox={ clickOnBox }
                                            version={ version }
                                            onUploadSuccess={ this.onUploadSuccess }
                                            uploadStart={ this.uploadStart }
                                            setPhoto={ () => this.setState({ hasPhoto: false })}
                                            logAction={this.logAction}
                                        />
                                    </li>
                                </ul>
                            </> :
                            <div className="additional-photo">
                                <UploadImageComponent
                                    item={ item }
                                    clickOnBox={ clickOnBox }
                                    version={ version }
                                    onUploadSuccess={ this.onUploadSuccess }
                                    uploadStart={ this.uploadStart }
                                    setPhoto={ () => this.setState({ hasPhoto: false })}
                                    logAction={this.logAction}
                                />
                            </div>
                    }
                </li>
            </ul>
        </section>
    }
}

// export default AdditionalItemDetails;
const mapStateToProps = ({}) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        clearItemAndCache,
        clearItem,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalItemDetails);
